<template>
  <div class="bg-light">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-lg-7 offset-lg-5">
          <p class="h2 font-regular my-7">
            Whether you need one item washed or a bulk order, we’re here to help.
             Order today to receive comprehensive service.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
